import {Product, Pricing} from '@/manager/product/models/product.model';
import {Companion} from '@/clickbuy/purchase/models/companion.model';


export interface PurchaseLineInterface {
    id?: string;
    product?: Product;
    amount?: number;
    productName?: string;
    typeOfProduct?: number;
    convocationTarget?: string;
    paymentPending?: number;
    totalPrice?: number;
    totalPriceTax?: number;
    totalPriceWithoutTax?: number;
    repeater?: boolean;
    gift?: boolean;
    color?: any;
    companionPurchaseLine?: Companion[];
    useBonoPrice?: boolean;
    useWebPrice?: boolean;
    useCoursePrice?: boolean;
    useBasePrice?: boolean;
    useConferencePrice?: boolean;
    useFusion?: boolean;
    useWebinar?: boolean;
    useTlp?: boolean;
    usePwp?: boolean;
    usePPago?: boolean;
    useShuttle?: boolean;
    useAmbassador?: boolean;
    useCn3?: boolean;
    useConferenceInsurance?: boolean;
}

export class PurchaseLine implements PurchaseLineInterface, Pricing {
    public id?: string;
    public product?: Product;
    public amount: number;
    public productName?: string;
    public typeOfProduct?: number;
    public convocationTarget?: string;
    public paymentPending?: number;
    public totalPrice?: number;
    public totalPriceTax?: number;
    public totalPriceWithoutTax?: number;
    public repeater?: boolean;
    public gift?: boolean;
    public color?: any;
    public companionPurchaseLine?: Companion[];
    public base?: number;
    public byHour?: number;
    public conference?: number;
    public course?: number;
    public reEnroll?: number;
    public reserve?: number;
    public repeat?: number;
    public tax?: number;
    public useBonoPrice?: boolean;
    public useWebPrice?: boolean;
    public useCoursePrice?: boolean;
    public useBasePrice?: boolean;
    public useConferencePrice?: boolean;
    public useFusion?: boolean;
    public useWebinar?: boolean;
    public useTlp?: boolean;
    public usePwp?: boolean;
    public usePPago?: boolean;
    public useShuttle?: boolean;
    public useAmbassador?: boolean;
    public useCn3?: boolean;
    public useConferenceInsurance?: boolean;

    constructor() {
        this.amount = 1;
        this.repeater = false;
        this.gift = false;
    }
}
